<template>
    <div>
        <div class="options d-flex align-items-center m-3 justify-content-between">
            <!-- <search table="categories"></search> -->

            <div class="d-flex col-sm-3 pl-0">
                <div class="d-flex w-100">
                    <input class="glued-right bg-lighter w-100" type="text" v-model="searchQuery" placeholder="Search">
                    <div class="glued-left dark"><i class="ico-search larger color-1"></i></div>
                </div>
            </div>

            <button class="btn" @click="addCategory">
                <i class="ico ico-add mt-1"></i> Add Category
            </button>

            <!-- <export></export> -->
        </div>
        <div v-if="getLoadingCategories" class="p-4 text-center">
            <loader></loader>
        </div>

        <div v-else>
            <list :header="header" :body="body" :rows="filteredResults" :actions="actions"></list>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import List from '@/tools/list/baseList'
    import Search from '@/tools/Search'
    import Export from '@/tools/Export'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data: function() {
            return {
                searchQuery:null,
                body: {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    customCells: {
                        name: this.formatName,
                        // status: this.formatStatus,
                    },
                    customRowEvent: this.view,
                },
                actions: {
                    label : 'Actions',
                    list: [
                        {
                            slug: 'edit',
                            title: 'Edit',
                            tooltip: 'Edit',
                            params: '',
                            class: '',
                            icon: 'ico-edit largest',
                            event: this.view,
                        },
                        {
                            slug: 'delete',
                            title: 'Delete',
                            tooltip: 'Delete',
                            params: '',
                            class: '',
                            icon: 'ico-delete largest',
                            event: this.remove,
                        }
                    ],
                },
                rowEvent: null,
            }
        },
        computed: {
            ...mapGetters([
                'getCategories',
                'getCategoriesLabels',
                'account',
                'getLoadingCategories'
            ]),
            header: function() {
                return {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    list: this.getCategoriesLabels,
                };
            },
            filteredResults: function() {
                if(this.searchQuery){
                    return this.getCategories.filter(category => {
                        return category.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                    })
                } else {
                    return this.getCategories
                }
            }
        },
        methods: {
            ...mapActions([
                'initCategories',
                'setSelectedItem',
                'removeItem',
                'openModal'
            ]),
            view: function(item) {
                this.setSelectedItem({ table: 'categories', id: item.id });
                this.openModal('CategoryView');
            },
            addCategory: function() {
                this.openModal('CategoryAdd')
            },
            remove: function(item) {
                this.removeItem({
                    table: 'categories',
                    object: 'category',
                    module: 'inventory',
                    fields: { supplierId: this.account.supplierId, Category: item }
                });
            },
            formatName: function(category) {
                return '<div class="bold">' + category.name + '</div>';
            },
            formatStatus: function(category) {
                return category.status ? 'Active' : '<div class="color-6">Inactive</div>';
            },
        },
        components: {
            List,
            Search,
            Export,
            Loader
        },
    }
</script>



// WEBPACK FOOTER //
// Categories.vue?2b7f8227